import { constantRoutes } from "@/public/router/index"

const state = {
  menus: [],
  realMenus: [],
  entrancePath:""
}

const mutations = {
  SET_MENUS: (state, menus) => {
    state.menus = menus
  },
  SET_REAL_MENUS: (state, menus) => {
    state.realMenus = menus.concat(constantRoutes)
  },
  SET_CURRENT_MENU: (state, entrancePath) => {
    state.entrancePath = entrancePath
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
